import { render, staticRenderFns } from "./DirectionInterest.vue?vue&type=template&id=b2c1a1fe&scoped=true&"
import script from "./DirectionInterest.vue?vue&type=script&lang=js&"
export * from "./DirectionInterest.vue?vue&type=script&lang=js&"
import style0 from "./DirectionInterest.vue?vue&type=style&index=0&id=b2c1a1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c1a1fe",
  null
  
)

export default component.exports